import { useEffect, useState } from "react";

const KEY = "kin-uploads";

export const getUploads = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "{}");
  } catch {
    return {};
  }
};

export const useSlotUpload = (slot) => {
  const [src, setSrc] = useState(null);
  useEffect(() => {
    if (slot) setSrc(getUploads()[slot] || null);
  }, [slot]);

  const save = (dataUrl) => {
    if (!slot) return;
    const all = getUploads();
    all[slot] = dataUrl;
    try {
      localStorage.setItem(KEY, JSON.stringify(all));
      setSrc(dataUrl);
    } catch {
      return false;
    }
    return true;
  };

  const clear = () => {
    if (!slot) return;
    const all = getUploads();
    delete all[slot];
    localStorage.setItem(KEY, JSON.stringify(all));
    setSrc(null);
  };

  return { uploaded: src, save, clear };
};
